import React, { Component } from 'react';
import { message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class PersonalInfo extends Component {
    state = {
        data: {},
    }

    componentDidMount() {
        this.queryUserData();
    }

    queryUserData = () => {
        const { userId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ data: res });
            },
        };
        $.sendRequest(options);
    }

    configUserTelephone = (openStatus) => {
        const { userId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.personal.configUserTelephone,
            data: {
                userId,
                openStatus,
            },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.queryUserData();
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { isChinese } = this.props;
        const { data } = this.state;
        const { user, vitaeTelphone } = data || {};
        const {
            userCompellation,
            enUserCompellation,
            enCityName,
            cityName,
            userEmail,
            userDetail,
            userMobile,
        } = user || {};
        const { gender } = userDetail || {};
        const { openStatus } = vitaeTelphone || {};
        const showUserPhone = openStatus !== 'CLOSE';
        const userMobileLen = (userMobile || '').length;
        return (
            <div style={{ marginBottom: 20 }}>
                <table cellPadding='0' cellSpacing='0' className="distribute information">
                    <tbody>
                        <tr>
                            <td className="distribute_td_left need-bold">{isChinese ? "姓名" : "Name"}：</td>
                            <td className="distribute_td_right">{isChinese ? userCompellation : enUserCompellation}</td>
                            <td className="distribute_td_left need-bold">{isChinese ? "性别" : "Gender"}：</td>
                            <td className="distribute_td_right">
                                {
                                    isChinese ?
                                        gender === 'FEMALE' ? '女' : '男'
                                    :
                                        gender
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="distribute_td_left need-bold">{isChinese ? "工作城市" : "Location"}：</td>
                            <td className="distribute_td_right">{isChinese ? cityName : enCityName}</td>
                            <td className="distribute_td_left need-bold">{isChinese ? "手机号码" : "TEL"}：</td>
                            <td className="distribute_td_right">
                                {showUserPhone ? userMobile : '*'.repeat(userMobileLen)}
                                {
                                    !!userMobileLen &&
                                    <a
                                        style={{marginLeft: 10}}
                                        onClick={() => this.configUserTelephone(showUserPhone ? 'CLOSE' : 'ON')}
                                    ><i className="icon iconfont">{showUserPhone ? '\ue6fe' : '\ue745'}</i></a>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="distribute_td_left need-bold">{isChinese ? "邮箱" : "E-mail"}：</td>
                            <td className="distribute_td_right">{userEmail}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PersonalInfo;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/PersonalInfo.js